var MasterPassPopup = (function ($, _, PaymentProviderBase, CheckoutSettings, PromiseUtil) {

	var MasterPassPopup = PaymentProviderBase.extend({

        type: 'masterpass',
        paymentOption: CheckoutSettings.PaymentOption.MasterPassPayment,
		_supportedTypes: [CheckoutSettings.PaymentType.MasterPass],
		_supportedOrderTypes: [CheckoutSettings.OrderPaymentType.MasterPassPayment],

		initialize: function (attrs, opts) {
			this._isMobile = opts.isMobile;
			this._scriptUrl = opts.scriptUrl;
			this._callbackUrl = window.location.protocol + '//' + window.location.host + window.location.pathname;
		},

		prepayment: function () {
			var apiMethod = this._isMobile ? 'masterPassMobilePayment' : 'masterPassPayment';

			return $.when(api[apiMethod]({ wait: true }), $.getScript(this._scriptUrl))
                .pipe(_.bind(this._openPopup, this))
                .promise();
		},

		complete: function (data_) {
			return api.masterPassPostTransaction({
				OAuthToken: data.oauth_token,
				OAuthVerifier: data.oauth_verifier,
				CheckoutResourceUrl: data.checkout_resource_url,
				PairingToken: data.pairing_token,
				PairingVerifier: data.pairing_verifier,
				IsMobile: this._isMobile
			}, { wait: true });
		},

		tryComplete: function (queryParams) {
			if (queryParams.oauth_token && queryParams.oauth_verifier) {
				return this.complete(queryParams);
			} else {
				return PromiseUtil.rejected();
			}
		},

		_openPopup: function (data) {
			var defer = new $.Deferred();
			var details = data.Value;
			var checkoutParams = {
				"requestToken": details.RequestToken,
				"callbackUrl": this._callbackUrl,
				"successCallback": defer.resolve,
				"failureCallback": defer.reject,
				"cancelCallback": defer.reject,
				"merchantCheckoutId": details.CheckoutID,
				"allowedCardTypes": [details.AllowedCardTypes],
				"version": details.Version,
				"suppressShippingAddressEnable": details.ShippingSupression,
				"requestBasicCheckout": false
			};

			if (details.RequestPairing) {
				$.extend(checkoutParams, {
					"pairingRequestToken": details.PairingRequestToken,
					"requestedDataTypes": details.RequestedDataTypes,
					"requestPairing": true
				});
			} else {
				$.extend(checkoutParams, {
					"cardId": details.CardID,
					"shippingId": details.AddressID,
					"precheckoutTransactionId": details.PrecheckoutTransactionID,
					"walletName": details.WalletName,
					"consumerWalletId": details.WalletID
				});
			}

			MasterPass.client.checkout(checkoutParams);

			return defer;
		}
	});

	return MasterPassPopup;
})($, _, PaymentProviderBase, CheckoutSettings, PromiseUtil);
